module.exports = __webpack_public_path__ + "static/media/user.64cb0065.svg";